import { UPDATE_MANAGEMENT_START } from "../../types";

export const update_management = (payload) => ({
    type: UPDATE_MANAGEMENT_START,
    payload,
});
